export const mapTermsAcceptance = (
  isEsigned?: boolean,
  isAgentsSignResponsibility?: boolean
) => {
  return !!isEsigned
    ? "Accepted"
    : isAgentsSignResponsibility
      ? "Agent's responsibility to sign policy application"
      : "Not accepted";
};
